import APIError from "../common/apierror"

class Client {
  constructor(url, accessToken, handleUnauthorized) {
    this.baseUrl = url;
    this.handleUnauthorized = handleUnauthorized;
    this.accessToken = accessToken;
  }

  async request(endpoint, requestType, options = {}) {
    let response;
    let url = this.baseUrl + endpoint;
    if (options.parameters) {
      url += "?" + new URLSearchParams(options.parameters);
    }

    response = await fetch(url, {
      ...options,
      method: requestType,
      headers: {
        Authorization: this.accessToken,
        ...(options.headers || {}),
      },
    });
 
    if (!response.ok) {
      console.log("got an error response", response);
      // TODO: need to handle for multiple 401
      if (response.status === 401) {
        this.handleUnauthorized();
      }

      //throw error to make promise reject
      console.log(response.body)
      throw new APIError(
        `Recieved error code response from API server for request (${url})`, 
        response.status, 
        response.statusText
      ); // RABTODO: What if response.status === 203?
  }
    else if (response.status != 203) {
      let responseData;
      let bodyText = await response.text();

      if (bodyText) {
        // Don't handle the error so this function's promise is rejected
        try {
          responseData = JSON.parse(bodyText);
        } catch (error) {
          throw new Error(
            `Unable to parse response body for request ${url} Error: ${error}`
          );
        }
      }

      return { data: responseData, response };
    }
  }

  async get(endpoint, options = {}) {
    return (await this.getResponse(endpoint, options)).data;
  }

  async getResponse(endpoint, options = {}) {
    return this.request(endpoint, "get", options);
  }

  async post(endpoint, data, options = {}) {
    return (await this.postResponse(endpoint, data, options)).data;
  }

  async postResponse(endpoint, data, options = {}) {
    return this.request(endpoint, "post", {
      ...options,
      body: JSON.stringify(data),
      headers: {
        ...(options.headers || {}),
        "Content-Type": "application/json",
      },
    });
  }

  async put(endpoint, data, options) {
    return (await this.putResponse(endpoint, data, options)).data;
  }

  async putResponse(endpoint, data, options = {}) {
    return this.request(endpoint, "put", {
      ...options,
      body: JSON.stringify(data),
      headers: {
        ...(options.headers || {}),
        "Content-Type": "application/json",
      },
    });
  }

  async delete(endpoint, options = {}) {
    return (await this.deleteResponse(endpoint, options)).data;
  }

  async deleteResponse(endpoint, options = {}) {
    return this.request(endpoint, "delete", options);
  }
}

export default Client;
